import { Base, withBreakpointObserver } from '@studiometa/js-toolkit';

/**
 * Header class.
 */
export default class ScrollSlider extends withBreakpointObserver(Base) {
  /**
   * App config.
   * @returns {object}
   */
  static config = {
    name: 'ScrollSlider',
    refs: ['message[]', 'content[]', 'mobile', 'device[]'],
    options: {
      inactiveBreakpoints: {
        type: String,
        default: 'xxs xs s',
      },
    },
  };

  /**
   * Log a nice message when app is ready.
   * @returns {void}
   */
  mounted() {
    this.position = 0;
    this.currentDevice = document.querySelector('.scroll-slider__device--current');
    const observer = new IntersectionObserver(this.checkIntersection.bind(this), {
      threshold: 0.8,
    });

    this.$refs.content.forEach((target) => {
      observer.observe(target);
    });
  }

  /**
   * Check message intersection with mobile
   * @param  {object} entries
   * @returns {void}
   */
  checkIntersection(entries) {
    if (entries[0].isIntersecting) {
      const { indexContent } = entries[0].target.dataset;
      this.activeMessage(indexContent);
      this.activeDevice(indexContent);
    }
  }

  /**
   * Reset style of unused messages
   * @param  {string} position
   * @returns {void}
   */
  resetMessage(position) {
    this.$refs.message.forEach((element, index) => {
      if (index === position - 1) return;
      element.classList.remove('scroll-slider__message-wrapper--current');
    });
  }

  /**
   * Active current Message
   * @param  {string} position
   * @returns {void}
   */
  activeMessage(position) {
    this.resetMessage(position);
    this.$refs.message[position - 1].classList.add('scroll-slider__message-wrapper--current');
    this.$refs.mobile.classList.toggle('variant');
  }

  /**
   * Change device on scroll
   * @param  {string} position
   * @returns {void}
   */
  activeDevice(position) {
    if (this.currentDevice === this.$refs.device[position - 1]) return;

    if (this.position < position) {
      this.currentDevice.classList.add('scroll-slider__device--out');
    }

    this.position = position;

    this.currentDevice.classList.remove('scroll-slider__device--current');
    this.currentDevice = this.$refs.device[position - 1];
    this.currentDevice.classList.add('scroll-slider__device--current');

    if (this.currentDevice.classList.contains('scroll-slider__device--out'))
      this.currentDevice.classList.remove('scroll-slider__device--out');
  }
}
